"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.mainPanelWidth = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var mainPanelWidth = 260;
exports.mainPanelWidth = mainPanelWidth;
var subPanelWidth = mainPanelWidth;

var styles = function styles(theme) {
  var _wrapper, _footerWrapper, _subOuterWrapper;

  if (!("scrollbars" in theme)) {
    theme.scrollbars = {
      main: {}
    };
  }

  return {
    docked: {
      width: "".concat(mainPanelWidth, "px"),
      position: "relative"
    },
    wrapper: (_wrapper = {}, (0, _defineProperty2.default)(_wrapper, theme.breakpoints.down("sm"), {
      maxWidth: "".concat(mainPanelWidth * 2, "px")
    }), (0, _defineProperty2.default)(_wrapper, "boxShadow", "none"), (0, _defineProperty2.default)(_wrapper, "borderRight", "1px solid " + theme.palette.divider), (0, _defineProperty2.default)(_wrapper, "transform", "translate(0px, 0px)"), (0, _defineProperty2.default)(_wrapper, "overflow", "hidden"), _wrapper),
    offsetTopBar: (0, _defineProperty2.default)({
      top: theme.mixins.toolbar.minHeight + theme.spacing(3.5),
      height: "calc(100% - ".concat(theme.mixins.toolbar.minHeight + theme.spacing(3.5), "px)")
    }, theme.breakpoints.down("xs"), {
      top: theme.mixins.toolbar.minHeight,
      height: "calc(100% - ".concat(theme.mixins.toolbar.minHeight, "px)")
    }),
    subNavOpen: {
      borderRight: "1px solid transparent"
    },
    shadow: {
      position: "absolute",
      top: 0,
      bottom: 0,
      right: 0,
      width: "80px",
      zIndex: theme.zIndex.drawer + 1,
      boxShadow: "inset -75px 0px 75px -75px rgba(0, 0, 0, 0.25)",
      opacity: 0,
      transition: "opacity 400ms",
      pointerEvents: "none"
    },
    shadowShowing: (0, _defineProperty2.default)({}, theme.breakpoints.up("md"), {
      opacity: 1
    }),
    scrollWrapper: {
      overflowY: "auto",
      position: "relative",
      flexGrow: 1
    },
    navigation: _objectSpread(_objectSpread({}, theme.scrollbars.main), {}, {
      maxHeight: "100%"
    }),
    hideOverflow: {
      overflow: "hidden"
    },
    footerWrapper: (_footerWrapper = {}, (0, _defineProperty2.default)(_footerWrapper, theme.breakpoints.up("md"), {
      paddingLeft: "".concat(mainPanelWidth, "px")
    }), (0, _defineProperty2.default)(_footerWrapper, "background", theme.palette.background.paper), (0, _defineProperty2.default)(_footerWrapper, "borderTop", "1px solid rgba(0, 0, 0, 0.12)"), (0, _defineProperty2.default)(_footerWrapper, "color", "#777"), (0, _defineProperty2.default)(_footerWrapper, "flex", "none"), (0, _defineProperty2.default)(_footerWrapper, "fontFamily", theme.typography.fontFamily), (0, _defineProperty2.default)(_footerWrapper, "fontSize", "0.8rem"), _footerWrapper),
    subHeader: (0, _defineProperty2.default)({
      padding: ".75rem"
    }, theme.breakpoints.up("md"), {
      display: "none"
    }),
    modal: {
      zIndex: theme.zIndex.appBar - 1
    },
    subDocked: {
      position: "absolute"
    },
    subOuterWrapper: (_subOuterWrapper = {
      boxShadow: "0px 0px 75px 0px rgba(0, 0, 0, 0.15)",
      width: "".concat(subPanelWidth + 1, "px")
    }, (0, _defineProperty2.default)(_subOuterWrapper, theme.breakpoints.up("md"), {
      marginLeft: "".concat(mainPanelWidth, "px"),
      zIndex: theme.zIndex.drawer - 1
    }), (0, _defineProperty2.default)(_subOuterWrapper, theme.breakpoints.down("sm"), {
      zIndex: theme.zIndex.drawer + 1,
      maxWidth: "".concat(subPanelWidth * 2, "px")
    }), (0, _defineProperty2.default)(_subOuterWrapper, "borderRight", "1px solid " + theme.palette.divider), _subOuterWrapper),
    subInnerWrapper: _objectSpread({}, theme.scrollbars.main),
    fillHeight: {
      display: "flex",
      flexGrow: 1,
      flexDirection: "column",
      overflowY: "auto",
      position: "relative",
      width: mainPanelWidth,
      boxSizing: "border-box"
    }
  };
};

exports.styles = styles;